import { connect } from 'react-redux';
import { branch, compose, lifecycle, withProps, withPropsOnChange } from 'recompose';
import { withRouter } from 'react-router';
import {
  getFrontendFlags,
  getRoleIdType,
  getUserUrlPrefix,
} from '../auth/selectors';
import { GLYPHS } from '../common/icon';
import { closeLoansDrawer, fetchLoans, fetchLoansLink, openLoansDrawer } from './actions';
import {
  getLoanOffer,
  getLoanOfferStatus,
  isInitialLoansLoadDone,
  canShowNoOfferView,
  getActiveLoansList,
  canUseStripeCapitalFinancing,
} from './selectors';
import { LOAN_STATUS } from './constants';
import { canUserViewBankAccounts } from '../common/helpers/users';

const mapStateToProps = state => ({
  canSeeStripeCapitalFinancing: canUseStripeCapitalFinancing(state),
  shopOrBarber: getRoleIdType(state),
  financingUrl: `${getUserUrlPrefix(state)}/financing`,
  initialLoansLoadDone: isInitialLoansLoadDone(state),
  hasActiveLoans: getActiveLoansList(state).length > 0,
  loanOffer: getLoanOffer(state),
  isNewOfferPending: getLoanOfferStatus(state) === LOAN_STATUS.DELIVERED,
  canViewBankAccount: canUserViewBankAccounts(state.auth.permissions),
  showNoOfferView: canShowNoOfferView(state),
  frontendFlags: getFrontendFlags(state),
});

const mapDispatchToProps = {
  openLoansDrawer,
  closeLoansDrawer,
  fetchLoans,
  fetchLoansLink,
};

const withLoansSidebarButtons = compose(
  withProps((props) => {
    const showLoansButton = props.initialLoansLoadDone && (props.hasActiveLoans || props.showNoOfferView);

    const showRedDotInNavIcon = props.isNewOfferPending
      || (props.showNoOfferView && !props.frontendFlags.stripeNoOfferPageViewed);

    const shouldOpenLoansDrawerOnNavClick = props.isNewOfferPending;

    return {
      loansButton: {
        id: 'stripeCapital',
        text: 'Stripe Capital',
        iconName: showRedDotInNavIcon ? GLYPHS.dollarCircleBalloon : GLYPHS.dollarCircle,
        show: showLoansButton,
        isActive: props.router.location.pathname === props.financingUrl,
        onClick: () => {
          props.router.push(props.financingUrl);

          if (shouldOpenLoansDrawerOnNavClick) {
            props.openLoansDrawer();
          }
        },
      },
    };
  }),
  withPropsOnChange(['initialLoansLoadDone'], (props) => {
    if (props.initialLoansLoadDone) {
      if (props.isNewOfferPending && props.loanOffer.showPopup) {
        props.openLoansDrawer();
      }

      window.dispatchEvent(new Event('sidebar-updated'));
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchLoans(this.props.shopOrBarber.id, this.props.shopOrBarber.type);
    },
  }),
);

const withNoLoansSidebarButtons = withProps(() => ({
  loansButton: { show: false },
}));

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    props => props.canSeeStripeCapitalFinancing,
    withLoansSidebarButtons,
    withNoLoansSidebarButtons,
  ),
);
